export const enum Gender {
  Man = 'Man',
  Woman = 'Woman',
  NonBinary = 'Non Binary',
  Other = 'Other',
}
